export default {
  namespaced: true,
  state: {
    data: []
  }
};

/*
export default {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    add(state, v) {
      state.data.push(v);
    },
    remove(state, v) {
      const pos = state.data.indexOf(v);
      state.data.splice(pos, 1);
    },
    set(state, v) {
      state.data = v;
    }
  }
};
*/
